/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { getColor } from '@airasia-phoenix/react-native/utils/utils';
import { pd } from '@airasia-phoenix/react-native/tokens';

export const styles = StyleSheet.create((pd) => ({
  container: {
    borderRadius: 24,
    borderColor: getColor(pd.sys.colour.outline_low),
    borderWidth: 1,
    paddingTop: 12,
    marginVertical: 24,
    marginHorizontal: 16,
  },
  fullScreenContainer: {
    borderRadius: 0,
    borderWidth: 0,
    flex: 1,
    marginHorizontal: 0,
    marginVertical: 0,
    paddingHorizontal: pd.ref.space.spacing20.px,
    paddingTop: 0,
  },
  contentContainer: {
    height: 160,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  tabContent: {
    width: '100%',
    overflowY: 'visible',
    justifyContent: 'center',
    transition: 'opacity 200ms ease-out' as any,
  },
  tabContentHidden: {
    opacity: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: -1,
  },
  fullScreenContentContainer: {
    alignItems: 'stretch',
    flex: 1,
    justifyContent: 'flex-start',
  },
  flightsContainer: { width: '100%' },
  hotelsContainer: {
    width: '100%',
    paddingBottom: pd.ref.space.spacing40.px,
  },
  tabView: {
    borderRadius: 24,
    overflow: 'hidden',
  },
}));
